import { Component, OnInit } from '@angular/core';
import {QrCodeIn} from '../model/qr-code-in';
import {OrdemServicoService} from '../service/ordem-servico.service';
import {constants} from '../app-constants';
import {DataService} from '../service/data.service';
import {DynamicDialogConfig, DynamicDialogRef} from 'primeng/api';
import {AnexoIn} from '../model/anexo-in';

@Component({
  selector: 'app-anexar-arquivos-dialog',
  templateUrl: './anexar-arquivos-dialog.component.html',
  styleUrls: ['./anexar-arquivos-dialog.component.css']
})

export class AnexarArquivosDialogComponent implements OnInit {

  constructor(private ordemServicoService: OrdemServicoService,
              public config: DynamicDialogConfig,
              public dialogRef: DynamicDialogRef,
              private data: DataService) {
  }

  anexo = new AnexoIn();
  hasFile = false;

  ngOnInit() {
  }

  onFileChanged(event) {
    const file = event.files[0];
    const fileReader = new FileReader();
    const self = this;

    fileReader.readAsDataURL(file);
    fileReader.onload = function (fileLoaderEvent) {
      const srcData = fileLoaderEvent.target as FileReader;
      const img = document.getElementById('outputTemp') as HTMLImageElement;
      img.src = srcData.result.toString();
      self.hasFile = true;
      self.anexo.nomeArquivo = file.name;
      self.anexo.fileInBase64 = img.src;
    };
  }

  onUpload() {
    this.dialogRef.close(this.anexo);
    let anexosLocalStorage = JSON.parse(localStorage.getItem(constants.anexosKey));
    if (anexosLocalStorage) {
      anexosLocalStorage.push(this.anexo);
    } else {
      anexosLocalStorage = [this.anexo];
    }
    localStorage.setItem(constants.anexosKey, JSON.stringify(anexosLocalStorage));
  }

  onClear() {
    this.anexo = new AnexoIn();
    this.hasFile = false;
  }
}
